import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import api from "@/api/admin";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async add(params: any) {
    return api.add(params);
  }

  @Action
  async edit(params: any) {
    return api.edit(params);
  }

  @Action
  async perms(params: any) {
    return api.perms(params);
  }

  @Action
  async savePerms(params: any) {
    return api.savePerms(params);
  }

  @Action
  async getStadium(params: any) {
    return api.stadium(params);
  }

  @Action
  async saveStadium(params: any) {
    return api.savestadium(params);
  }

  @Action
  async permissions(params: any) {
    return api.permissions(params);
  }

  @Action
  async taisamAccounts(params: any) {
    return api.taisamAccounts(params);
  }

  @Action
  async addTaisamAccount(params: any) {
    return api.addTaisamAccount(params);
  }

  @Action
  async editTaisamAccount(params: any) {
    return api.editTaisamAccount(params);
  }

  @Action
  async templatemessage(params: any) {
    return api.templatemessage(params);
  }

  @Action
  async roles(params: any) {
    return api.roles(params);
  }

  @Action
  async rolegroups(params: any) {
    return api.rolegroups(params);
  }

  @Action
  async listtaisam(params: any) {
    return api.listtaisam(params);
  }

  @Action
  async deletetaisam(params: any) {
    return api.deletetaisam(params);
  }

}
